import { getMethods as getDataSecurityMethods } from './DataSecurity';
import { getMethods as getActionsMethods } from './Actions';
import { getMethods as getActivityMethods } from './Activity';
import { getMethods as getPasswordMethods } from './Password';
import { getMethods as getConfigurationMethods } from './Configuration';
import { getMethods as getPermissionMethods } from './Permission';
import { getMethods as getSharedMethods } from './Shared';
import { getMethods as getPermissionGroupMethods } from './PermissionGroup';
import { getMethods as getAnnouncementMethods } from './Announcement';
import { getMethods as getWebObjectMethods } from './WebObject';
import { getMethods as getUserStartupMethods } from './UserStartup';
import { getMethods as getDashboardMethods } from './Dashboard';
import { getMethods as getAIMethods } from './AI';

const getController = (service: 'main') => ({
	DataSecurity: getDataSecurityMethods(service, 'DataSecurity'),
	Actions: getActionsMethods(service, 'Actions'),
	Activity: getActivityMethods(service, 'Activity'),
	Password: getPasswordMethods(service, 'Password'),
	Configuration: getConfigurationMethods(service, 'Configuration'),
	Permission: getPermissionMethods(service, 'Permission'),
	Shared: getSharedMethods(service, 'Shared'),
	PermissionGroup: getPermissionGroupMethods(service, 'PermissionGroup'),
	Announcement: getAnnouncementMethods(service, 'Announcement'),
	WebObject: getWebObjectMethods(service, 'WebObject'),
	UserStartup: getUserStartupMethods(service, 'UserStartup'),
	Dashboard: getDashboardMethods(service, 'Dashboard'),
	AI: getAIMethods(service, 'AI')
});

export { getController };
